import axios from "axios";

// Use the computer serving the frontend, including when opened from a phone.
const defaultApiUrl = `${window.location.protocol}//${window.location.hostname}:8000/api/`;
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || defaultApiUrl });
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
api.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401 && localStorage.getItem("token")) {
        localStorage.clear();
        window.location.assign("/login");
    }
    return Promise.reject(error);
});
export default api;
